import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path fill="#0AA1F4" d="M8 8L6 6l1-1 3 3-3 3-1-1 2-2z"></path>
    </svg>
  )
}

export default Icon
